module.exports = __webpack_public_path__ + "img/storage_300.f3a2d7bc.jpg";